/* eslint-disable */
import { Chip, Tooltip, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import PXDashboardIcon from '../../assets/PXDashboardIcon';
import _keyBy from 'lodash/keyBy';
import _pick from 'lodash/pick';

const color = {
  good: { color: 'rgba(3, 152, 85, 1)', backgroundColor: 'rgba(236, 253, 243, 1)' },
  average: { color: 'rgba(220, 104, 3, 1)', backgroundColor: 'rgba(255, 250, 235, 1)' },
  poor: { color: 'rgba(217, 45, 32, 1)', backgroundColor: 'rgba(254, 243, 242, 1)' },
};

const customStyle = {
  insightIcon: {
    display: 'none',
  },
  insightIconVisible: {
    display: 'inline-block',
    position: 'absolute',
    right: '0',
    cursor: 'pointer',
  },
};

const ToolTip = ({ title, tooltiptext }) => (
  <Tooltip title={tooltiptext} arrow>
    <Typography variant="body1" style={{ fontWeight: '600' }}>
      {title}
    </Typography>
  </Tooltip>
);

const DSLTCell = ({ cell, deltaKey }) => {
  const { color, text } = cell.row.original[deltaKey];

  return (
    <Typography
      noWrap
      style={{
        color: color,
      }}
    >
      {text}
    </Typography>
  );
};

const DeltaCell = ({ cell, deltaKey }) => {
  const { delta, trend } = cell.row.original[deltaKey];

  return (
    <Typography
      noWrap
      style={{
        color: trend,
      }}
    >
      {delta}
    </Typography>
  );
};

const PxTable = [
  {
    accessorKey: 'status',
    header: 'Status',
    minSize: 100,
    maxSize: 110,
    size: 100,
    Cell: ({ cell }) => (
      <Chip
        style={{
          borderRadius: '4px',
          padding: '2px, 6px, 2px, 6px',
          textTransform: 'capitalize',
          ...(color[cell.getValue()] || {}),
        }}
        label={cell.getValue()}
      />
    ),
  },
  {
    accessorKey: 'insight',
    header: 'Insights',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'name',
    header: 'Dealership Name',
    minSize: 170,
    maxSize: 500,
    size: 170,
  },
  {
    accessorKey: 'parent',
    header: 'Group Name',
    minSize: 170,
    maxSize: 500,
    size: 170,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'pxOwnerName',
    header: 'PX Owner',
    minSize: 140,
    maxSize: 500,
    size: 140,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },

  {
    accessorKey: 'dslt.days',
    header: <ToolTip title="DSLT" tooltiptext="Days since last touchpoint" />,
    minSize: 100,
    maxSize: 120,
    size: 100,
    Cell: ({ cell }) => <DSLTCell cell={cell} deltaKey="dslt" />,
  },

  {
    accessorKey: 'totalUsers',
    header: 'Users',
    minSize: 110,
    maxSize: 110,
    size: 110,
  },
  {
    accessorKey: 'mau',
    header: 'MAU',
    minSize: 65,
    maxSize: 65,
    size: 65,
  },
  {
    accessorKey: 'mauPercent',
    header: 'MAU%',
    minSize: 78,
    maxSize: 78,
    size: 78,
  },
  {
    accessorKey: 'mauDelta.delta',
    header: 'Δ MAU',
    minSize: 78,
    maxSize: 78,
    size: 78,
    Cell: ({ cell }) => <DeltaCell cell={cell} deltaKey="mauDelta" />,
  },

  {
    accessorKey: 'dau',
    header: 'DAU',
    minSize: 62,
    maxSize: 62,
    size: 62,
  },
  {
    accessorKey: 'dauPercent',
    header: 'DAU%',
    minSize: 78,
    maxSize: 78,
    size: 78,
  },
  {
    accessorKey: 'dauDelta.delta',
    header: 'Δ DAU',
    minSize: 78,
    maxSize: 78,
    size: 78,
    Cell: ({ cell }) => <DeltaCell cell={cell} deltaKey="dauDelta" />,
  },
  {
    accessorKey: 'rs',
    header: <ToolTip title="RS" tooltiptext="RockED Score" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'ms',
    header: <ToolTip title="MS" tooltiptext="Management Score" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'as',
    header: <ToolTip title="AS" tooltiptext="Activity Score" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'cs',
    header: <ToolTip title="CS" tooltiptext="Consistency Score" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'lu',
    header: <ToolTip title="LU" tooltiptext="Learning Units" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'gc',
    header: <ToolTip title="GC" tooltiptext="Guides Completed" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'sc',
    header: <ToolTip title="SC" tooltiptext="Stories Completed" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'cc',
    header: <ToolTip title="CC" tooltiptext="Capstone Completed" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'gs',
    header: <ToolTip title="GS" tooltiptext="Guides Shared" />,
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    accessorKey: 'luDisabled',
    header: 'LU Disabled',
    minSize: 120,
    maxSize: 120,
    size: 120,
  },
  {
    accessorKey: 'leadPipelineStatus',
    header: 'Sales Pipeline Status',
    minSize: 200,
    maxSize: 200,
    size: 200,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'source',
    header: 'Plans',
    minSize: 134,
    maxSize: 134,
    size: 134,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'category',
    header: 'Category',
    minSize: 110,
    maxSize: 110,
    size: 110,
  },
  {
    accessorKey: 'luDelta.delta',
    header: 'Δ LU',
    minSize: 70,
    maxSize: 70,
    size: 70,
    Cell: ({ cell }) => <DeltaCell cell={cell} deltaKey="luDelta" />,
  },
];

const AllTab = [
  'status',
  'insight',
  'name',
  'parent',
  'pxOwnerName',
  'dslt.days',
  'totalUsers',
  'mau',
  'mauPercent',
  'mauDelta.delta',
  'dau',
  'dauPercent',
  'dauDelta.delta',
  'rs',
  'ms',
  'as',
  'cs',
  'lu',
  'gc',
  'sc',
  'cc',
  'gs',
  'luDisabled',
  'leadPipelineStatus',
  'source',
];
const MoverAndLoserTab = [
  'insight',
  'name',
  'dslt.days',
  'category',
  'mau',
  'mauPercent',
  'mauDelta.delta',
  'dau',
  'dauPercent',
  'dauDelta.delta',
  'lu',
  'luDelta.delta',
  'luDisabled',
];
const Communication = [
  'insight',
  'name',
  'parent',
  'pxOwnerName',
  'dslt.days',
  'totalUsers',
  'mau',
  'mauPercent',
  'mauDelta.delta',
  'dau',
  'dauPercent',
  'dauDelta.delta',
  'rs',
  'ms',
  'as',
  'cs',
  'lu',
  'gc',
  'sc',
  'cc',
  'gs',
  'luDisabled',
  'leadPipelineStatus',
  'source',
];

const PxTableColumns = (tabId, handleOpenInsightPopup, setIndividualDealerId) => {
  let selectedTab = AllTab;

  // Determine which tab is selected based on the tabId
  if (tabId === 1 || tabId === 2) {
    selectedTab = MoverAndLoserTab;
  } else if (tabId === 3) {
    selectedTab = Communication;
  }

  const pxTableMap = _keyBy(PxTable, 'accessorKey');
  const filteredColumns = _pick(pxTableMap, selectedTab);

  // Add a new column for "Insights"
  if (filteredColumns.insight) {
    filteredColumns.insight.Cell = ({ cell }) => {
      const handleClick = () => {
        const clickedDataId = cell.row.original.id;
        handleOpenInsightPopup(clickedDataId);
      };

      return (
        <div style={{ cursor: 'pointer' }} onClick={handleClick}>
          <PXDashboardIcon color="#622FEE" />
        </div>
      );
    };
  }

  if (filteredColumns.name) {
    filteredColumns.name.Cell = ({ cell }) => {
      const handleClick = () => {
        const dealerId = cell.row.original.id;
        setIndividualDealerId(dealerId);
      };
      return (
        <Typography onClick={handleClick} style={{ color: '#622FEE', cursor: 'pointer' }}>
          {cell.getValue()}
        </Typography>
      );
    };
  }

  return Object.values(filteredColumns);
};

export default PxTableColumns;
